import { createAuthProvider, IDPHint, getIdpHintChoiceAuthConfig } from '@newfront-insurance/next-auth';

import { getConfig } from '@/config';

const { API, KEYCLOAK } = getConfig();

export const AuthProvider = createAuthProvider({
  ...getIdpHintChoiceAuthConfig([IDPHint.GSUITE, IDPHint.ENTRAID]),
  authApiConfig: {
    clientId: KEYCLOAK.CLIENT_ID,
    realm: KEYCLOAK.REALM.EMPLOYEES,
    url: API.AUTH,
  },
});
